import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpLayoutDashboardSimpleComponent } from './sp-layout-dashboard-simple.component';



@NgModule({
  declarations: [SpLayoutDashboardSimpleComponent],
  exports: [
    SpLayoutDashboardSimpleComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class SpLayoutDashboardSimpleModule { }
